import OrdersTabe from "./Tables/ordersTable";

function Orders() {
    return ( <div>
        {/* <OrdersTabe/> */}
    </div> );
}

export default Orders;